import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'

import type { ContactpersoonExtern } from '../../types/Contactpersoon'

export type { ExternFields }

type ExternFields = Pick<
  ContactpersoonExtern,
  'naam' | 'rol' | 'contactOrganisatie' | 'telefoonnummer' | 'emailadres'
>

interface Props {
  values: ExternFields
  onChange: (values: ExternFields) => void
  errors: Record<string, boolean>
}

export function CreateExternFields({ values, onChange, errors }: Props) {
  const { naam, rol, contactOrganisatie, telefoonnummer, emailadres } = values

  return (
    <Box>
      <TextField
        sx={{ pr: 1, pb: 1 }}
        onChange={(e) => onChange({ ...values, naam: e.target.value })}
        value={naam}
        variant="standard"
        label="Naam"
        fullWidth
        error={errors['naamError']}
        slotProps={{ htmlInput: { maxLength: 50 } }}
      />
      <TextField
        sx={{ pr: 1, pb: 1 }}
        onChange={(e) => onChange({ ...values, rol: e.target.value })}
        value={rol}
        variant="standard"
        label="Rol"
        fullWidth
        error={errors['rolError']}
        slotProps={{ htmlInput: { maxLength: 50 } }}
      />
      <TextField
        sx={{ pr: 1, pb: 1 }}
        onChange={(e) =>
          onChange({ ...values, contactOrganisatie: e.target.value })
        }
        value={contactOrganisatie || ''}
        variant="standard"
        label="Organisatie"
        fullWidth
        slotProps={{ htmlInput: { maxLength: 50 } }}
      />
      <TextField
        sx={{ pr: 1, pb: 1 }}
        onChange={(e) =>
          onChange({ ...values, telefoonnummer: e.target.value })
        }
        value={telefoonnummer}
        variant="standard"
        label="Telefoonnummer"
        fullWidth
        error={errors['telefoonnummerError']}
        slotProps={{ htmlInput: { maxLength: 20 } }}
      />
      <TextField
        sx={{ pr: 1, pb: 1 }}
        onChange={(e) => onChange({ ...values, emailadres: e.target.value })}
        value={emailadres}
        variant="standard"
        label="Emailadres"
        fullWidth
        error={errors['emailadresError']}
        slotProps={{ htmlInput: { maxLength: 50 } }}
      />
    </Box>
  )
}
